import { render, staticRenderFns } from "./newDaydata.vue?vue&type=template&id=2604a051"
import script from "./newDaydata.vue?vue&type=script&lang=js"
export * from "./newDaydata.vue?vue&type=script&lang=js"
import style0 from "./newDaydata.vue?vue&type=style&index=0&id=2604a051&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports